<template>
  <div class="flex items-center gap-x-14">
    <p class="text-black-800" data-testid="headerUserName">{{ user?.name }}</p>

    <router-link
      :to="{ name: $routeNames.settingsProfile }"
      class="shrink-0 w-44 h-44 flex items-center justify-center bg-blue-3-600 rounded-full cursor-pointer"
    >
      <PhUser size="20" color="white" />
    </router-link>
  </div>
</template>

<script lang="ts" setup>
const { user } = storeToRefs(useAuthStore())
</script>
